import { RequestStatus } from '@src/utils/enums';
import { getLatestFormVersionByRequestType } from './latestVersions';
import { formRegistry } from './registry';
import type { FormDescriptor } from './types';

export const resolveEffectiveFormVersion = (args: {
  requestTypeId: number;
  requestStatus?: string | null;
  storedFormVersion?: number | null;
}): number => {
  const { requestTypeId, requestStatus, storedFormVersion } = args;

  if (requestStatus !== RequestStatus.Draft) {
    return storedFormVersion && storedFormVersion > 0 ? storedFormVersion : 1;
  }

  const latest = getLatestFormVersionByRequestType(requestTypeId);
  return latest ?? 1;
};

export const resolveFormDescriptor = (args: {
  requestTypeId: number;
  requestStatus?: string | null;
  storedFormVersion?: number | null;
}): FormDescriptor | null => {
  const { requestTypeId, requestStatus, storedFormVersion } = args;

  const entry = formRegistry[requestTypeId];
  if (!entry) return null;

  const version = resolveEffectiveFormVersion({
    requestTypeId,
    requestStatus,
    storedFormVersion,
  });

  const variant = entry.getVariant?.({ requestTypeId, version });
  const prefix = variant ?? entry.formKeyPrefix ?? String(requestTypeId);
  const formKey = `${prefix}@${version}`;

  return {
    FormComponent: entry.FormComponent,
    version,
    variant,
    formKey,
    getMetadata: () => entry.getMetadata({ version, variant }),
  };
};
